var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"headerBrand",on:{"click":_vm.navigateTo}},[_c('img',{staticClass:"headerBrand__icon",attrs:{"src":require("../assets/img/MySpaceBrand.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }